import { WidgetData } from '../../interfaces'
import { FormData, WidgetInstance } from '../types'
import { AppThunk } from './store'
import { resetWidget, selectWidgetById, goToNextPage, updateFormState } from './widgets'
import { waitForAnimationEnd } from '../helpers/animation'
import { processPendingActions, processPendingActionsBeforeSend } from './actions'

// transforms internal widget form data to submit data
export function getWidgetData(widget: WidgetInstance): WidgetData {
  const { data } = widget.formState

  return Object.entries(data).reduce<WidgetData>((res, [key, { value }]) => {
    if (value?.length > 0) {
      res[key] = value
    }
    return res
  }, {})
}

interface SubmitParams {
  data: FormData
  valid: boolean
}

export const sendData =
  (id: number, silent = false): AppThunk<Promise<boolean>> =>
  async (dispatch, getState, runtime) => {
    const widget = selectWidgetById(getState(), id)
    if (widget.formState.sent) {
      console.info('form already sent', id)
      return false
    }

    dispatch(updateFormState(widget.id, { sending: silent ? 'silent' : true }))
    await runtime.sendData(widget.id, getWidgetData(widget))
    await waitForAnimationEnd(widget.id)
    dispatch(updateFormState(widget.id, { sending: false, sent: true }))

    return true
  }

export const submitForm =
  (id: number, { data, valid }: SubmitParams): AppThunk<Promise<boolean>> =>
  async dispatch => {
    dispatch(updateFormState(id, { data, valid }))
    if (!valid) {
      return false
    }

    const { shouldSendData, pageChanged } = dispatch(goToNextPage(id))

    if (shouldSendData) {
      const sendPromise = dispatch(sendData(id, pageChanged))
      await dispatch(processPendingActionsBeforeSend(id))
      const result = await sendPromise
      await dispatch(processPendingActions(id))
      if (!pageChanged) {
        dispatch(resetWidget(id))
      }
      return result
    } else {
      await dispatch(processPendingActions(id))
      return true
    }
  }
